//Interfaces
import { FilteredResultListState } from "../../../results/models/state/filtered-result-list-state";
import { FacetStateValues } from "../../models/state/facet-state-values";
import { Result } from "../../../results/models/result";

//Util
import { doesResultMatchFacets } from "./does-result-match-facets";

export const applyFacetsToResults = (
	results: Result[],
	selectedFacets: FacetStateValues,
) => {
	if (results === null || results === undefined) {
		return;
	}

	var matchedResults = [] as Result[];
	var unmatchedResults = [] as Result[];

	results.forEach((result) => {
		//Check to see if the results is a match for the currently selected facets
		if (doesResultMatchFacets(result, selectedFacets)) {
			matchedResults.push(result);
		} else {
			unmatchedResults.push(result);
		}
	});

	return {
		MatchedResults: matchedResults,
		UnmatchedResults: unmatchedResults,
	} as FilteredResultListState;
};
